module.exports = __webpack_public_path__ + "static/media/homeImageMobile@2x.35460511.png";